<template>
  <div>
    <!-- Edit -->
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      v-model="visible"
      :title="`Manage ${internal ? internal.internal_assessment.name : '' } marks for ${subject ? subject.subject.name : ''} (${subject ? subject.subject.abbreviation : ''})`"
      onOk="handleOk"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Save</a-button>
      </template>
      <a-spin :spinning="loading">
        <p class="text-muted mb-3">Enter the marks corresponding to the roll nos.</p>
        <a-form class="mb-3" :form="form">
          <div class="row neo-exam-mark-form-table-container" v-if="internalData">
            <div class="col-6 col-md-4 col-lg-3" v-for="student_enrollment in internalData" :key="student_enrollment.id">
              <table class="table table-bordered table-sm-responsive">
                <tbody>
                  <tr>
                    <th scope="row" style="min-width:45px;">
                      {{ student_enrollment.roll_no }}
                    </th>
                    <td>
                      <a-form-item class="d-none">
                        <a-input
                          v-decorator="[`student_marks[${student_enrollment.id}][enrollment_id]`, { initialValue: student_enrollment.id }]"
                        />
                      </a-form-item>
                      <a-form-item class="m-0">
                        <a-input-number
                          placeholder=""
                          v-decorator="[`student_marks[${student_enrollment.id}][internal_assessment_mark]`, {initialValue: student_enrollment.final_internal_assessment_mark ? getInternalMark(student_enrollment.final_internal_assessment_mark) : '',
                          rules: [{ required: false }]
                          }]"
                          :min="0"
                          :max="internal.internal_assessment_weightage"
                          :disabled="false"
                          style="width: 100%;"
                        />
                      </a-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'internalMarksForm',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      internalData: null,
      subject: null,
      internal: null,
      examData: null,
      classId: null,
      sectionId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openInternalMarksForm', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
    examSubjects: function () {
      return this.examData.class_section_exam_subject
    },
  },
  methods: {
    showModal: function(internalData, examSubject, internal, classId, sectionId) {
      this.visible = true
      this.internalData = internalData
      this.subject = examSubject
      this.internal = internal
      this.classId = classId
      this.sectionId = sectionId
    },
    getInternalMark(internalMarks) {
      const internalMark = find(internalMarks, {
        internal_assessment_id: this.internal.internal_a_id,
        subject_id: this.subject.subject_id,
      })
      if (internalMark) {
        return internalMark.final_student_internal_assessment_mark
      } else {
        return ''
      }
    },
    handleSubmit: function (e) {
      this.loading = true
      if (this.classId && this.sectionId) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$confirm({
              title: `Are you sure?`,
              content: `Click on the OK button to update internal marks!`,
              onOk: () => {
                let formData = {}
                formData.internal_assessment_id = this.internal.internal_a_id
                formData.class_id = this.classId
                formData.section_id = this.sectionId
                formData.subject_id = this.subject.subject_id

                formData.student_marks = values.student_marks.flat().filter(element => {
                  if (element) {
                    return true
                  } else {
                    return false
                  }
                }).map(el => {
                  if (!el.internal_assessment_mark) {
                    el.internal_assessment_mark = null
                  }
                  return el
                })

                this.$http
                  .post('/api/finalstudentinternalassessmentmark', formData)
                  .then(() => {
                    this.$emit('updated')
                    this.loading = false
                    this.visible = false
                    this.$notification['success']({
                      message: 'Successfully updated',
                      description: 'Subject marks updated successfully!',
                    })
                  })
                  .catch(error => {
                    this.loading = false
                    this.$neoNotify.error(error)
                  })
              },
              onCancel: () => {
                this.loading = false
              },
            })
          }
        })
      }
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
